<template>
  <v-container class="pa-0">
    <h4>What would you like us to do with your mail?</h4>
    <v-radio-group required dense v-model="answer">
      <v-radio dense :key="text" :value="text" :label="text" v-for="text in options"></v-radio>
    </v-radio-group>
      <div v-if="answer == options[2]">
        <p>Which address would you like to forward to?</p>
        <MailingComponent storedName="MailForwardingAddress"></MailingComponent>
      </div>
  </v-container>
</template>

<script>
  import MailingComponent from './MailingComponent';
  export default {
    name: 'MailHandling',
    components: {
      MailingComponent,
    },
    data () {
      return {
        options: [
          "Keep at reception, notify by phone",
          "Keep at reception, notify by email",
          "Forward to another address (postage charges may apply)",
          "Open mail and scan to email (time charges may apply)",
        ],
      }
    },
    computed: {
      answer: {
        get() {
          if(this.$store.state.additional_services.mail_handling_selection) {
            return this.$store.state.additional_services.mail_handling_selection;
          } else {
            this.$store.commit('additional_services/setMailSelection', this.options[1]);
            return this.options[1];
          }
        },
        set(value) {
          this.$store.commit('additional_services/setMailSelection', value);
        },
      }
    },
    methods: {
      getAddressData: function (addressData, placeResultData, id) {
        console.log(id);
      },
    }
  }
</script>
<style scoped>
</style>
